import template from './form.html';
import { FormActions } from 'core/services/form';
import productosI18N from 'i18n/productos/es.json';
import commonI18N from 'i18n/common/es.json';
import { rest } from 'core/api';
import configFile from 'config.json';
import { formatErrorMessage } from 'core/util';
import nuevoDetalle from "./detalle.nuevo.html";

export let ProductoFormComponent = {
  templateUrl: template,
  selector: 'productoForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(productosI18N).concat(Object.keys(commonI18N));


FormController.$inject = [
  '$state', '$ngRedux', 'ngNotify', '$stateParams', 'Filter', 'BasicFactory', '$timeout', '$scope', 'AuthorizationService', 'CustomModal'
];

function FormController($state, $ngRedux, ngNotify, $stateParams, Filter, BasicFactory, $timeout, $scope, AuthorizationService, CustomModal) {
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.doSubmit = doSubmit.bind(this);

  this.loadAdicionales = loadAdicionales.bind(this);
  this.loadServicios = loadServicios.bind(this);
  this.newDetalle = newDetalle.bind(this);
  this.deleteDetalle = deleteDetalle.bind(this);
  this.newDetalleFormCreate = newDetalleFormCreate.bind(this);
  this.deleteDetalleFormCreate = deleteDetalleFormCreate.bind(this);

  let unsubscribe;
  const generacionFilter = Filter.path('codigo').eq('generacion_codigo_producto');

  const valoresEstadoProductoFilter = Filter.path('tipo.codigo').eq('estado_producto');
  const valoresMonedaFilter = Filter.path('tipo.codigo').eq('moneda');
  const valoresFilter = valoresEstadoProductoFilter.or(valoresMonedaFilter);

  const activoFilter = Filter.path('activo').eq(true);
  const familiaFilter = Filter.path('ultimoNivel').eq(true).and(activoFilter);
  this.uploadOptions = {
    imageOnly: true,
    target: configFile.serverURL + '/adjuntos',
    publicPath: configFile.publicURL
  };

  this.$onDestroy = () => {
    this.form();
    $ngRedux.dispatch(rest.actions.valores.reset());
    unsubscribe();
  };

  this.localModel = {};
  this.localModel.montoBaseMinimo = 0;

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

    if ($stateParams.uid) {
      this.title = this.view ? this.translations['Ver producto'] : this.translations['Editar producto'];
      this.formEdit('productos', $stateParams.uid);
    } else {
      this.title = this.translations['Nuevo producto'];
      this.form();
    }

    this.canCreatePrecios = AuthorizationService.hasPermission('create_precios');

    $ngRedux.dispatch(rest.actions.categoriasProductos());
    $ngRedux.dispatch(rest.actions.parametros.get({ filter: JSON.stringify(generacionFilter) }));
    $ngRedux.dispatch(rest.actions.valores.get({ filter: JSON.stringify(valoresFilter) }));
    $ngRedux.dispatch(rest.actions.tiposImpuestos({ filter: JSON.stringify(activoFilter) }));
    $ngRedux.dispatch(rest.actions.familiasProductos({ filter: JSON.stringify(familiaFilter) }));
    $ngRedux.dispatch(rest.actions.proveedores({ filter: JSON.stringify(activoFilter) }));
    $ngRedux.dispatch(rest.actions.marcas({ filter: JSON.stringify(activoFilter) }));
    $ngRedux.dispatch(rest.actions.unidadesMedidas({ filter: JSON.stringify(activoFilter) }));
    $ngRedux.dispatch(rest.actions.especialidades({ filter: JSON.stringify(activoFilter) }));
    $ngRedux.dispatch(rest.actions.tiposAtributoClienteRequeridos());
  };

  function mapStateToThis(state) {
    this.handleStatus(state);
    this.submitted = state.form.flags ? state.form.flags.submitted : false;
    let parametros = state.parametros.data.filter((p) => p.codigo === 'generacion_codigo_producto');
    let modoGeneracion = {};

    if (parametros) {
      modoGeneracion = parametros[0];
    }
    this.model = state.form.model;
    if (!this.model.precio) {
      this.model.precio = {};
    }
    this.model.precio.moneda = state.valores.data.filter(v => v.value === 'Guaraníes')[0];
    this.model.presentacion = this.model.presentacion || {};

    if (!this.model.id && state.valores.data && state.valores.data.length > 0) {
      let estados = state.valores.data.filter(v => v.tipo.codigo === 'estado_producto');
      let estadoActivo = estados.filter(v => v.value === 'Activo')[0];
      this.model.estado = estadoActivo;
      this.model.duracion = 30;

      if (!this.model.detalles) {
        this.model.detalles = [];
      }
    }

    if (this.model.detalles && this.model.detalles.length) {
      this.model.detalles = this.model.detalles.sort(function(a, b) {
        if (a.orden < b.orden) {
          return -1;
        }
        if (a.orden > b.orden) {
          return 1;
        }
        // a debe ser igual b
        return 0;
      });
    }

    if (!this.model.id && !this.localModel.ordenPrevio) {
      let ordenPrevio = [];
      if (this.model && this.model.detalles) {
        this.model.detalles.forEach(element => {
          ordenPrevio.push(element.orden);
        });
        this.localModel.ordenPrevio = ordenPrevio;
      }
    }

    return {
      form: state.form,
      categoriasProductos: state.categoriasProductos.data,
      categoriasProductosConProducto: state.categoriasProductos.data.filter((v) => v.clase.value === 'Producto'),
      isModoGeneracionAutomatico: modoGeneracion && modoGeneracion.valor.value === 'Automático',
      estadosProductos: state.valores.data.filter((v) => v.tipo.codigo === 'estado_producto'),
      tiposImpuestos: state.tiposImpuestos.data,
      familiasProductos: state.familiasProductos.data,
      proveedores: state.proveedores.data,
      marcas: state.marcas.data,
      unidadesMedidas: state.unidadesMedidas.data,
      especialidades: state.especialidades.data,
      tiposAtributoClienteRequeridos: state.tiposAtributoClienteRequeridos.data
    };
  }

  /**
   * Función que se encarga de mostrar mensajes de error/exito en base al estado actual
   *
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.productos.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.form.created) {
      ngNotify.set(this.translations['Datos guardados correctamente'], 'success');
      $state.go('home.productos.list');
    }
  }

  function doSubmit() {
    let data = Object.assign({}, this.model);

    if (data.servicioPadre) {
      data.servicioPadre = {id: data.servicioPadre.id};
    }

    if (data.categoria.clase.value !== 'Producto') {
      delete data.presentacion;
      delete data.precio;
    } else {
      if (!data.precio.monto) {
        data.precio = null;
      }
    }

    if (data.foto && data.foto.length) {
      data.foto = data.foto[0];
    }

    if (this.model.id) {
      delete data.detalles;
    }

    this.save('productos', data);
  }

  function loadAdicionales(query, tipo) {
    let filter = Filter.path('estado.value').eq('Activo');

    if (tipo) {
      filter = filter.and(Filter.path('tipo.value').eq(tipo));
    }

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query));
    }

    BasicFactory.setup('adicionales');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }


  function loadServicios(query) {
    let filter = Filter.path('categoria.clase.value').eq('Servicio')
      .and(Filter.path('servicioPadre').isNull());

    if (this.model.id) {
      filter = filter.and(Filter.path('id').notEq(this.model.id));
    }

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query));
    }

    BasicFactory.setup('productos');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  this.filterPadres = filterPadres.bind(this);

  function filterPadres(servicio) {
    return true;
  }


  this.filterAdicionales = filterAdicionales.bind(this);

  function filterAdicionales(item) {
    if (item.adicional) {
      return item.adicional.estado.value === 'Activo';
    }
    return true;
  }


  this.onChangeOrden = onChangeOrden.bind(this);

  function onChangeOrden(item, index) {
    let { ordenPrevio } = this.localModel;
    this.model.detalles.forEach((element) => {
      if (element.orden === item.orden && item.id !== element.id) {
        element.orden = ordenPrevio[index];
      }
    });
  }

  function newDetalle(detalleEdit) {
    console.log('[newDetalle]');
    console.log('[this]', this);
    console.log('[this.model.id]', this.model.id);
    if (!this.model.id) {
      return this.newDetalleFormCreate();
    }
    const self = this;
    const orden = this.model.detalles.length + 1;
    this.localModel.detalle = detalleEdit || { orden, adicional: {} };
    CustomModal.open({
      title: 'Nuevo adicional de producto',
      size: 'lg',
      templateUrl: nuevoDetalle,
      vm: this,
      detalle: this.localModel.detalle,
      ok: function() {
        // checks tipos obligatorios
        if (!self.localModel.detalle.orden || !(self.localModel.detalle.adicional && self.localModel.detalle.adicional.id)) {
          ngNotify.set('Campos requeridos faltantes', 'warn');
          return false;
        }

        // check repetido
        const repetido = (self.model.detalles || []).filter(detalle => self.localModel.detalle.id !== detalle.id).reduce((repetido, detalle) => {
          return repetido || (detalle.orden === self.localModel.detalle.orden || detalle.adicional.id === self.localModel.detalle.adicional.id );
        }, false);
        if (repetido) {
          ngNotify.set('Ya existe el adicional o el orden', 'warn');
          return false;
        }

        // Crear ProductoAdicional
        if (!self.localModel.detalle.id) {
          self.localModel.detalle.producto = { id: self.model.id };
          // request para guardar
          $ngRedux.dispatch(rest.actions.crearProductoDetalle({id: self.model.id}, { body: JSON.stringify(self.localModel.detalle) },
            (err, data) => {
              if (!err && data && data.id) {
                // agregar al model en caso de exito
                self.model.detalles.push(data);
                ngNotify.set(self.translations['Nuevo adicional de producto guardado'], 'success');
              } else if (err) {
                ngNotify.set(err.message, 'warn');
              }
            }));
        } else {
          // Request para actualizar el detalle de precio
          $ngRedux.dispatch(rest.actions.editarProductoDetalle({id: self.model.id}, { body: JSON.stringify(self.localModel.detalle) },
            (err, data) => {
              if (!err && data && data.id) {
                // Actualizar en el array de detalles el que fue editado
                self.model.detalles = self.model.detalles.reduce((detalles, detalle) => {
                  const toPush = detalle.id === data.id ? data : detalle;
                  detalles.push(toPush);
                  return detalles;
                }, []);
                ngNotify.set(self.translations['Adicional de producto actualizado'], 'success');
              } else if (err) {
                ngNotify.set(err.message, 'warn');
              }
            }));
        }

      }

    });
  }

  function deleteDetalle(detalle) {
    if (!this.model.id) {
      return this.deleteDetalleFormCreate(detalle);
    }
    const self = this;
    CustomModal.open({
      title: 'Eliminar adicional de producto',
      message: '¿Seguro que desea eliminar el adicional de producto?',
      ok: function() {
        $ngRedux.dispatch(rest.actions.eliminarProductoDetalle({ id: detalle.id }, {}, (err, data) => {
          if (!err) {
            _.remove(self.model.detalles, detalle);
            ngNotify.set('Adicional de producto eliminado correctamente', 'success');
          } else if (err) {
            ngNotify.set(err.message, 'warn');
          }
        }));
      }
    });

  }

  function newDetalleFormCreate() {
    console.log('[newDetalleFormCreate]');
    console.log('[this]', this);
    let orden = this.model.detalles.length + 1;
    this.model.detalles.push({
      orden
    });
    this.localModel.ordenPrevio.push(orden);
  }

  function deleteDetalleFormCreate(detalle) {
    console.log('[deleteDetalleFormCreate]');
    const index = this.model.detalles.indexOf(detalle);
    console.log('[detalle]', detalle);
    console.log('[index]', index);
    console.log('[this.localModel.ordenPrevio]', this.localModel.ordenPrevio);
    console.log('[this.model.detalles]', this.model.detalles);
    if (index > -1) {
      this.localModel.ordenPrevio.splice(index, 1);
    }
    _.remove(this.model.detalles, detalle);
  }
}



// WEBPACK FOOTER //
// ./src/components/productos/form/form.component.js